var eventName = 'turbo:load';

if (document.getElementById('shopify-app-flash')) {
  document.addEventListener(eventName, function flash() {
    
    var flashElement = document.getElementById('shopify-app-flash');
    if (flashElement) {
      var flashData = JSON.parse(flashElement.dataset.flash);
 
      var Toast = window['app-bridge'].actions.Toast;

      if (flashData.notice) {
        Toast.create(app, {
          message: flashData.notice,
          duration: 5000,
        }).dispatch(Toast.Action.SHOW);
      }

      if (flashData.error) {
        Toast.create(app, {
          message: flashData.error,
          duration: 5000,
          isError: true,
        }).dispatch(Toast.Action.SHOW);
      }
    }

    document.removeEventListener(eventName, flash)
  });
}
